import { currentRole } from '@/authProvider'
import StackAPI from '@/lib/StackAPI'
import {
  EarningsAndOrdersData,
  ParsedEarningsAndOrdersData
} from '../types/Sale'

type Params = {
  id: string
  startDate: string
  endDate: string
}

const getEarningsAndOrders = async ({
  id,
  startDate,
  endDate
}: Params): Promise<ParsedEarningsAndOrdersData> => {
  const partnerRole = currentRole()

  const { data } = await StackAPI().get<EarningsAndOrdersData>({
    path: `partners/sales/${id}/performance`,
    params: {
      context: partnerRole.type.toLowerCase(),
      sale_id: id,
      end_at: endDate,
      start_at: startDate
    }
  })

  const estimatedEarnings =
    data.earnings?.reduce((acc, data) => {
      return acc + data[1]
    }, 0) || 0

  const netItemsSold =
    data.orders?.reduce((acc, data) => {
      return acc + data.net_count
    }, 0) || 0

  const result = {
    earningsData: data.earnings,
    ordersData: data.orders,
    estimatedEarnings,
    netItemsSold
  }

  return result
}

export { getEarningsAndOrders }
